// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3toU0","col":"styles_col___WTqp","fulfillmentStatus":"styles_fulfillmentStatus__1w24d","emailCol":"styles_emailCol__3OSK1"};